const SECOND_MS = 1000
const MINUTE_MS = 60 * SECOND_MS
const HOUR_MS = 60 * MINUTE_MS
const DAY_MS = 24 * HOUR_MS
const MONTH_MS = 30 * DAY_MS
const YEAR_MS = 365 * DAY_MS

const relativeTimeFormatter = new Intl.RelativeTimeFormat('en', {
  numeric: 'always',
})

const getTime = value => {
  if (!value) {
    return null
  }

  const date = value instanceof Date ? value : new Date(value)
  const time = date.getTime()

  return Number.isNaN(time) ? null : time
}

export const formatRelativeTime = (value, now = Date.now()) => {
  const time = getTime(value)
  const nowTime = getTime(now)

  if (time === null || nowTime === null) {
    return ''
  }

  const diff = time - nowTime
  const absoluteDiff = Math.abs(diff)

  if (absoluteDiff < 45 * SECOND_MS) {
    return diff > 0 ? 'in a few seconds' : 'a few seconds ago'
  }

  if (absoluteDiff < 45 * MINUTE_MS) {
    return relativeTimeFormatter.format(Math.round(diff / MINUTE_MS), 'minute')
  }

  if (absoluteDiff < 22 * HOUR_MS) {
    return relativeTimeFormatter.format(Math.round(diff / HOUR_MS), 'hour')
  }

  if (absoluteDiff < 26 * DAY_MS) {
    return relativeTimeFormatter.format(Math.round(diff / DAY_MS), 'day')
  }

  if (absoluteDiff < 320 * DAY_MS) {
    return relativeTimeFormatter.format(Math.round(diff / MONTH_MS), 'month')
  }

  return relativeTimeFormatter.format(Math.round(diff / YEAR_MS), 'year')
}

export const isOlderThanHours = (value, hours, now = Date.now()) => {
  const time = getTime(value)
  const nowTime = getTime(now)

  if (time === null || nowTime === null) {
    return false
  }

  return nowTime - time >= hours * HOUR_MS
}
